import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { ReactComponent as MoreInfo } from "../../../../../../assets/moreInfo.svg";
import { ReactComponent as Spinner } from "../../../../../../assets/icons/spinner.svg";
import { ReactComponent as ReUploadIcon } from "../../../../../../assets/images/companyIcons/ReUploadIcon.svg";
import { ReactComponent as DeleteIcon } from "../../../../../../assets/images/companyIcons/delete.svg";
import { isVerified } from "../../../../../../utils/Helper";

import {
  setUploadData,
  setFinancialData,
} from "../../../../../../store/Company/companySlice";
import { useSelector, useDispatch } from "react-redux";
import {
  useUpdateCompanyMutation,
  useUpdateFinanceMutation,
  useUpdateFinanceDraftMutation,
  useUpdateBankMutation,
  useCreateFinanceMutation,
  useCreateBankMutation,
  useCreateCompanyFinanceMutation,
  useGetCompanyQuery,
} from "../../../../../../store/Company/companyApiSlice";
import pdf1 from "../../../../../../assets/images/pdf.svg";
import useCompanyUpdate from "../useCompanyFollowUpdate";
import { uploadFilePath } from "../../../../../../constants/s3UploadPath";
import { uploadFileToS3 } from "../../../../../../utils/uploadFileToS3";

const SingleDocument = ({}) => {
  const { financialData } = useSelector((state) => state.company);
  const { currentEditingCompany } = useSelector((state) => state.company);
  const { token, userInfo } = useSelector((state) => state.auth);
  const { id } = useParams();
  const { refetch } = useGetCompanyQuery({
    companyId: id,
    token,
  });
  const fileInputRef = useRef([]);
  const dispatch = useDispatch();
  const [optionDisplay, setOptionDisplay] = useState(Array(5).fill(false));
  const [isDragging, setIsDragging] = useState(false);
  const [previewUrl, setPreviewUrl] = useState(Array(5).fill(null));
  const [updateCompany] = useUpdateCompanyMutation();
  const [updateFinance] = useUpdateFinanceMutation();
  const [bankInfo, setBankInfo] = useState();
  const [createFinance] = useCreateFinanceMutation();
  const [createCompanyFinance] = useCreateCompanyFinanceMutation();
  const [uploadedFile, setUploadedFile] = useState("");
  const [createBankMutation, { isLoading }] = useCreateBankMutation();
  const [updateBankMutation, { isLoading: isUpdating }] =
    useUpdateBankMutation();
  const handleUpdateCompany = useCompanyUpdate();
  const [isDataLoading, setIsDataLoading] = useState(false)
  const [currentLoadingIndex, setCurrentLoadingindex] = useState(-1);

  useEffect(() => {
    let bankDetailArray = currentEditingCompany?.bankDetails;

    bankDetailArray?.map((bank_Details) => setBankInfo(bank_Details));
  }, []);
 
  useEffect(() => {
    if (currentEditingCompany) {
      const updatedPreviewUrls = [...previewUrl];
      updatedPreviewUrls[0] = currentEditingCompany?.MOA;
      updatedPreviewUrls[1] = currentEditingCompany.trade_license;
      updatedPreviewUrls[2] = currentEditingCompany.VAT_certificate;
      setPreviewUrl(updatedPreviewUrls);
    }
  }, []);

  const letters = [
    {
      name: "Upload MOA",
      update: "Update MOA",
    },
    {
      name: "Upload Trade License",
      update: "Update Trade License",
    },
    {
      name: "VAT Certificate",
      update: "Update VAT Certificate",
    },
  ];
  const uploadApi = async (files, fieldName, index) => {
    try {
      setCurrentLoadingindex(index);
      setIsDataLoading(true);
      const formData = new FormData();
      formData.append("request_type", "Financial statement Update draft");
      formData.append(
        "audited_financial_statement",
        currentEditingCompany?.financialDetails[0]?.last_audited
      );
      formData.append(
        "financial_year_end",
        currentEditingCompany?.financialDetails[0]?.financial_year_end
      );
      formData.append(
        "last_audited",
        currentEditingCompany?.financialDetails[0]?.last_audited
      );
      formData.append(
        "audit_firm_companyID",
        currentEditingCompany?.financialDetails[0]?.audit_firm_companyID
      );

      if (
        fieldName === "VAT Certificate" ||
        fieldName === "Upload Trade License" ||
        fieldName === "Upload MOA"
      ) {
        const fileString = await uploadFileToS3(uploadFilePath?.moa, files, token, currentEditingCompany?.companyID);
        if(fileString?.url){
        formData.append(
          fieldName === "Upload MOA"
            ? "MOA"
            : fieldName === "VAT Certificate"
            ? "VAT_certificate"
            : fieldName === "Upload Trade License"
            ? "trade_license"
            : fieldName === "Bank Confirmation Letter"
            ? "Update Bank Confirmation Letter"
            : "audited_financial_statement",
          fileString?.url
        );

        const data = await updateCompany({
          token,
          companyId: currentEditingCompany?.companyID,
          data: formData,
        }).unwrap();
        if (data) {
          refetch();
          localStorage.setItem('currentEditingCompany', JSON.stringify(data))
          const result = await handleUpdateCompany(
            currentEditingCompany.companyID,
            "Documents Updated",
            token
          );
          if (!result.success) {
            console.error(result.error);
          }
          dispatch(setUploadData(data));
        }
      }
      } else if (fieldName === "Bank Confirmation Letter") {
        if (bankInfo && bankInfo?.bankID?.bankID) {
          const formData = new FormData();
          formData.append("bank_name", bankInfo?.bankID?.bank_name);
          formData.append("IBAN", bankInfo?.bankID?.IBAN);
          formData.append("country", bankInfo?.bankID?.country);
          const bankConfUrl = uploadFileToS3(uploadFilePath?.bank, files, token, currentEditingCompany?.companyID);
          formData.append("bank_conf_letter", bankConfUrl?.url);

          try {
            const res = await updateBankMutation({
              data: formData,
              bankId: bankInfo?.bankID?.bankID,
              token,
            }).unwrap();
          } catch (error) {}
        } else {
          const formData = new FormData();
          formData.append(
            "current_companyID",
            currentEditingCompany?.companyID
          );
          formData.append("bank_name", bankInfo?.bankID?.bank_name);
          formData.append("IBAN", bankInfo?.bankID?.IBAN);
          formData.append("country", bankInfo?.bankID?.country);
          const bankConfUrl = uploadFileToS3(uploadFilePath?.bank, files, token, currentEditingCompany?.companyID);
          formData.append("bank_conf_letter", bankConfUrl?.url);

          try {
            const res = await createBankMutation({
              data: formData,
              bankID: bankInfo?.bankID?.bankID,
              token,
            }).unwrap();
          } catch (error) {}
        }
      } else {
        if (financialData) {
          const auditedfUrl = uploadFileToS3(
            uploadFilePath?.auditedFinancial,
            files,
            token,
            currentEditingCompany?.companyID
          );
          formData.append("audited_financial_statement", auditedfUrl?.url);
          formData.append(
            "financial_year_end",
            currentEditingCompany?.financialDetails[0]?.financial_year_end
          );
          formData.append(
            "last_audited",
            currentEditingCompany?.financialDetails[0]?.last_audited
          );
          formData.append(
            "state",
            currentEditingCompany?.financialDetails[0]?.state
          );
          formData.append(
            "country",
            currentEditingCompany?.financialDetails[0]?.country
          );
          formData.append(
            "audit_firm_companyID",
            currentEditingCompany?.financialDetails[0]?.audit_firm_companyID
          );

          const data = await updateFinance({
            token,
            company_financialID:
              currentEditingCompany?.financialDetails[0]?.company_financialID,
            data: formData,
          }).unwrap();

          if (data) {
            dispatch(setFinancialData(data));
          }
        } else {
          const auditedfUrl = uploadFileToS3(
            uploadFilePath?.auditedFinancial,
            uploadedFile,
            token,
            currentEditingCompany?.companyID
          );
          formData.append("audited_financial_statement", auditedfUrl?.url);
          formData.append(
            "financial_year_end",
            currentEditingCompany?.financialDetails[0]?.financial_year_end
          );
          formData.append(
            "last_audited",
            currentEditingCompany?.financialDetails[0]?.last_audited
          );
          formData.append(
            "state",
            currentEditingCompany?.financialDetails[0]?.state
          );
          formData.append(
            "country",
            currentEditingCompany?.financialDetails[0]?.country
          );
          formData.append(
            "audit_firm_companyID",
            currentEditingCompany?.financialDetails[0]?.audit_firm_companyID
          );
          const finance = await createFinance({
            data: formData,
            token,
          }).unwrap();

          if (finance) {
            dispatch(setFinancialData(finance));

            const companyFinance = await createCompanyFinance({
              data: {
                company_financialID:
                  currentEditingCompany?.financialDetails[0]
                    ?.audit_firm_companyID,
                companyID: currentEditingCompany?.companyID,
              },
              token,
            }).unwrap();
          }
        }
      }
      setCurrentLoadingindex(-1);
      setIsDataLoading(false);
    } catch (e) {}
  };

  const handleFileChange = async (e, index) => {
    const file = e.target.files[0];
    const nameValue = e.target.parentElement.previousElementSibling.innerText;
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const updatedPreviewUrls = [...previewUrl];
        if (file.type == "application/pdf") {
          updatedPreviewUrls[index] = pdf1;
        } else {
          updatedPreviewUrls[index] = reader.result;
        }
        setPreviewUrl(updatedPreviewUrls);
      };
      reader.readAsDataURL(file);
    }

    await uploadApi(file, nameValue, index);
    setOptionDisplay((prevState) => {
      const updatedOptionDisplay = [...prevState];
      updatedOptionDisplay[index] = !updatedOptionDisplay[index];
      return updatedOptionDisplay;
    });
  };

  const handleChooseFile = async (index) => {
    const file = fileInputRef.current[index].click();
    setOptionDisplay((prevState) => {
      const updatedOptionDisplay = [...prevState];
      updatedOptionDisplay[index] = !updatedOptionDisplay[index];
      return updatedOptionDisplay;
    });
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    setIsDragging(index);
  };

  const handleDragLeave = (e, index) => {
    setIsDragging(false);
    setOptionDisplay((prevState) => {
      const updatedOptionDisplay = [...prevState];
      updatedOptionDisplay[index] = !updatedOptionDisplay[index];
      return updatedOptionDisplay;
    });
  };

  const handleDrop = async (e, index) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];

    const nameValue = e.target.parentElement.previousElementSibling.innerText;
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        const updatedPreviewUrls = [...previewUrl];
        updatedPreviewUrls[index] = reader.result;
        setPreviewUrl(updatedPreviewUrls);
      };
      reader.readAsDataURL(file);
    }

    await uploadApi(file, nameValue, index);
  };
  const handleOption = (index, option) => {
    if (option === "reupload") {
      fileInputRef.current[index].click();
    } else if(!isDataLoading){
      setOptionDisplay((prevState) => {
        const updatedOptionDisplay = [...prevState];
        updatedOptionDisplay[index] = !updatedOptionDisplay[index];
        return updatedOptionDisplay;
      });
    }
  };
  const deleteDocument = (index) => {
    const updatedPreviewUrls = [...previewUrl];
    updatedPreviewUrls[index] = null;
    setPreviewUrl(updatedPreviewUrls);
    setOptionDisplay((prevState) => {
      const updatedOptionDisplay = [...prevState];
      updatedOptionDisplay[index] = !updatedOptionDisplay[index];

      return updatedOptionDisplay;
    });
  };
  function get_url_extension(url) {
    if (url !== undefined) {
      return url.split(/[#?]/)[0].split(".").pop().trim();
    }
  }

  const viewDoc = (doclink) => {
    window.open(doclink, "_blank");
  };
  return (
    <form className="flex flex-wrap justify-between">
      {true &&
        letters?.map((item, index) => (
          <div className=" w-[49%] text-left mb-5">
            <div className="text-primary font-semibold mb-2 text-[12px] md:text-[18px] sm:text-[13px]">
              {item.name}
            </div>
            <div
              className={`border-2 ${
                previewUrl[index] ? "border" : "border-dashed"
              } border-input rounded-lg relative h-48 p-8 ${
                isDragging ? "bg-gray-100" : ""
              }`}
              onDragOver={(e) => handleDragOver(e, index)}
              onDragLeave={handleDragLeave}
              onDrop={(e) => handleDrop(e, index)}
            >
              <input
                type="file"
                accept=".jpg, .jpeg, .png, .pdf"
                onChange={(e) => handleFileChange(e, index)}
                ref={(el) => (fileInputRef.current[index] = el)}
                className="hidden"
              />
              {previewUrl[index] != undefined && previewUrl[index] ?  (
                (isDataLoading && index === currentLoadingIndex)? <div className="flex justify-center items-center flex-col"><Spinner /><p>Uploading</p></div> : <div className="w-full h-36 overflow-hidden border-input rounded-lg border-2 bg-uploadImg">
                  {get_url_extension(previewUrl[index]) == "pdf" ? (
                    <img
                      src={pdf1}
                      alt="Preview PDF"
                      height="40px"
                      className="mx-auto w-3/5"
                      onClick={() => {
                        viewDoc(previewUrl[index]);
                      }}
                    />
                  ) : (
                    <img
                      src={previewUrl[index]}
                      onClick={() => {
                        viewDoc(previewUrl[index]);
                      }}
                      alt="Preview IMG"
                      height="40px"
                      className="mx-auto w-3/5"
                    />
                  )}
                </div>
              ) : (
                <div className="text-center">
                  <div>
                    <svg
                      className="w-12 h-12 mx-auto mb-4 text-gray-500"
                      width="49"
                      height="38"
                      viewBox="0 0 49 38"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      onClick={() => handleChooseFile(index)}
                    >
                      <path
                        d="M40.4927 12.6436C38.2742 3.80599 29.3117 -1.55986 20.4741 0.65858C13.5677 2.3923 8.55291 8.36136 8.03622 15.4632C3.13241 16.2719 -0.187381 20.9027 0.621312 25.8065C1.3402 30.1661 5.11773 33.3588 9.53605 33.3412H17.0352V30.3416H9.53605C6.22273 30.3416 3.53671 27.6555 3.53671 24.3422C3.53671 21.0289 6.22273 18.3429 9.53605 18.3429C10.3644 18.3429 11.0359 17.6714 11.0359 16.843C11.0284 9.388 17.0659 3.33841 24.5209 3.33101C30.9743 3.32454 36.5296 7.88685 37.778 14.2183C37.8381 14.5266 37.9934 14.8083 38.2222 15.0236C38.4509 15.2388 38.7414 15.3769 39.0528 15.4182C43.1532 16.0021 46.0037 19.7994 45.4199 23.8997C44.8956 27.5816 41.752 30.323 38.0329 30.3416H32.0336V33.3412H38.0329C43.8313 33.3237 48.5175 28.609 48.4999 22.8106C48.4853 17.9839 45.1815 13.789 40.4927 12.6436Z"
                        fill="#5B8098"
                      />
                      <path
                        d="M23.4696 18.778L17.4702 24.7773L19.585 26.8921L23.0346 23.4575V37.8409H26.0343V23.4575L29.4689 26.8921L31.5837 24.7773L25.5843 18.778C24.9993 18.1964 24.0546 18.1964 23.4696 18.778Z"
                        fill="#5B8098"
                      />
                    </svg>
                    <p className="md:text-[16px] sm:text-[11px] text-[10px] text-secondarytwo">
                      {isDragging ? "Drop the file here" : "Drag & drop or "}
                      <button
                        type="button"
                        onClick={() => handleChooseFile(index)}
                        className="text-primaryText font-semibold focus:outline-none"
                      >
                        Choose file
                      </button>
                      to upload
                      <span className="md:text-[14px] text-secondary block text-[10px] sm:text-[10px]">
                        Supported format : JPG, JPEG, PNG, PDF
                      </span>
                    </p>
                  </div>
                </div>
              )}
              {previewUrl[index] && (
                <div className="bg-white absolute w-full border-input rounded-b-lg px-8 py-2 border-t-2 bottom-0 left-0 h-16 flex justify-between items-center">
                  <div>
                    <div className="text-secondarytwo sm:text-[10px] md:text-[14px] text-[8px]">
                      {item.update}
                    </div>
                    <div className="text-secondary tracking-wider sm:text-[10px] md:text-[14px] text-[10px] ">
                    </div>
                  </div>
                  <div className="justify-end items-center flex flex-row-reverse ">
                    <MoreInfo
                      className={`cursor-pointer mr-0 ml-auto `}
                      onClick={() => handleOption(index, "more-info")}
                    />

                    {optionDisplay[index] && !isDataLoading && (
                      <ul className="border-2 border-input rounded-lg mt-36 bg-white p-3 w-full z-10">
                        <li
                          className="py-1 flex items-center gap-2.5 text-f16 text-secondarytwo cursor-pointer"
                          onClick={() => {
                            handleOption(index, "reupload");
                          }}
                        >
                          {" "}
                          <div>
                            <ReUploadIcon />
                          </div>
                          Re - Upload Document
                        </li>
                        <hr className="my-3" />
                        <li
                          className="py-1 flex items-center gap-2.5 text-f16 text-decline cursor-pointer"
                          onClick={() => deleteDocument(index)}
                        >
                          <DeleteIcon /> Delete
                        </li>
                      </ul>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        ))}
    </form>
  );
};

export default SingleDocument;
